import React from "react";
import { Dialog, makeStyles } from "@material-ui/core";
import { useState } from "react";
import WebApi from "api/ApiConstants";

const FlightTicketSendEmail = (props) => {
    const classes = useStyles();
    const [emailAddress, setEmailAddress] = useState(props.receiverEmail);

    const handleClose = () => {
        props.setIsSendEmail(false);
        setEmailAddress("");
    };

    const handleInputValueChange = (e) => {
        if(e.target.value !== "") {
            setEmailAddress(e.target.value);
        }
    };

    const sendEmail = () => {
        if(emailAddress && emailAddress !== "") {
            props.setIsLoading(true);
            let params = {...props.requestParams};
            params.email = emailAddress;
            WebApi.emailFlightTicketPdf(params, (response) => {
                props.setIsLoading(false);
                if(response.success) {
                    props.setIsSendEmail(false);
                    setEmailAddress("");
                    props.setInfoText(`Successfully sent email to ${emailAddress}`);
                    props.setIsSuccess(true);
                } else {
                    props.setInfoText(`Failed to generate pdf file!`);
                    props.setIsError(true);
                }
                
            }, (error) => {
                props.setIsLoading(false);
                console.error("Error", error);
                props.setInfoText(`Failed to send email to ${emailAddress}!`);
                props.setIsError(true);
            });
        } else {
            props.setInfoText("Email cannot be empty!");
            props.setIsError(true);
        }
    };

    return(
        <Dialog
            open={props.isSendEmail}
            onClose={handleClose}
            PaperProps={{
                className: classes.dialogPaper
            }}
        >
            <div className="ticket-delivery-card flex-box align-items-center">
                <span className="dialog-close-button" onClick={handleClose}>x</span>
                <div className="form-element ticket-col">
                    <label>Email</label>
                    <input value={emailAddress || ""} onChange={handleInputValueChange}/>
                </div>
                <div className="form-element ticket-col btn-element">
                    <button className="btn btn-submit" onClick={sendEmail}>Send Email</button>
                </div>
            </div>
        </Dialog>
    );
};

export default FlightTicketSendEmail;

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        "& .ticket-delivery-card": {
            position: "relative"
        },
        "& button, .dialog-close-button": {
            cursor: "pointer"
        },
        "& .dialog-close-button": {
            position: "absolute",
            top: 0,
            right: 0,
            height: 20,
            width: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    }
}));
